import { useEffect, useState } from 'react'
import { injectScript } from '@jetshop/core/analytics/utils/script'

/**
 * @param {object} props
 * @param {import('@jetshop/core/types').Product} props.product
 * @example
 * // Usage
 * const { videos, startPlayer, closePlayer } = useVideoly(product)
 */
export const useVideoly = (product) => {
   const [state, setState] = useState({})

   useEffect(() => {
      injectScript({
         src: '//api.videoly.co/1/quchbox/0/704/quch.js',
      })
   }, [])

   useEffect(() => {
      window.videolyInitCallbacks = {
         onVideoDataLoaded: [handleVideoLoaded],
      }

      function handleVideoLoaded(error, data) {
         // console.log("handleVideoLoaded")
         if (error) {
            console.error('Videoly error::', error)
         }

         // console.log('Videoly data::', data)

         const {
            videos,
            actions: { startPlayer, closePlayer },
         } = data

         setState({ videos, startPlayer, closePlayer })
      }
   }, [product])

   return state
}
